import { GROUP_SET } from '../../constants/endpoints';
import request from './request';

const fetchGroupSet = async (accessToken, { groupSetId }) => {
  const config = {
    method: 'get',
    url: GROUP_SET(groupSetId),
  };

  const response = await request(accessToken, config);
  return response.data;
};

export default fetchGroupSet;
